module.exports = __webpack_public_path__ + "img/title-ja.db9b7c87.png";